module.exports = __webpack_public_path__ + "static/img/project-feature-hunter.8483c3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-feature-hunter.png
// module id = MDsx
// module chunks = 0